// NPM Imports
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CreatableSelect from "react-select/lib/Creatable";
import { Tooltip, Button, Label, Input } from "../../../../revvComponents";

const getValue = data => {
  const returnValue = {};
  if (data) {
    returnValue.label = data;
    returnValue.value = data;
  }
  return returnValue;
};

// Comonents Imports
const AddRecipientReviewerSection = ({
  reviewersList,
  addUserToTheList,
  handleValue,
  removeReviewer,
  checkFormValidation,
  // userOptions,
}) => (
  <div className="recipientlistsection-addreviewerlist">
    {/* ------------ Form Fields Labels Section ------------*/}
    <div className="docsharingpopup-recipient-sharingform-row">
      <div className="docsharingpopup-recipient-sharingform-col docsharingpopup-recipient-email">
        <Label>Recipients email</Label>
      </div>
      <div className="docsharingpopup-recipient-sharingform-col docsharingpopup-recipient-first-name">
        <Label>First name</Label>
      </div>
      <div className="docsharingpopup-recipient-sharingform-col docsharingpopup-recipient-last-name">
        <Label>Last name</Label>
      </div>

      <div className="docsharingpopup-sharingform-col recipient-delete" />
    </div>
    {reviewersList &&
      reviewersList.map((reviewer, index) => (
        <div className="recipientlistsection-formrow">
          <div
            className="docsharingpopup-sharingform-col docsharingpopup-recipient-email"
            data-test="docsharing-popup-user-email">
            <CreatableSelect
              placeholder="Enter email"
              formatCreateLabel={userInput =>
                `+ Add "${userInput.toLowerCase()}"`
              }
              className={reviewer.notValid ? "not-valid-email-recipients" : ""}
              onChange={eventData =>
                handleValue(eventData, index, "user_email")
              }
              // options={userOptions}
              value={
                getValue(reviewer.user_email).label
                  ? getValue(reviewer.user_email)
                  : ""
              }
              isClearable={
                getValue(reviewer.user_email).label !== "Enter email"
              }
              data-test="docsharing-popup-user-email"
              autoFocus
            />
          </div>
          <div className="docsharingpopup-sharingform-col docsharingpopup-recipient-first-name">
            <Input
              type="text"
              className="doc-recipients-input-box"
              disabled={reviewer.disabled}
              value={reviewer.first_name}
              placeholder="First name"
              data-test="docsharing-user-firstname"
              onChange={e => handleValue(e, index, "first_name")}
            />
          </div>
          <div className="docsharingpopup-sharingform-col docsharingpopup-recipient-last-name">
            <Input
              type="text"
              className="doc-recipients-input-box"
              disabled={reviewer.disabled}
              value={reviewer.last_name}
              placeholder="Last name"
              data-test="docsharing-user-lastname"
              onChange={e => handleValue(e, index, "last_name")}
            />
          </div>

          <div className="docsharingpopup-sharingform-col recipient-delete">
            <Tooltip
              placement="top"
              align={{
                offset: [0, 4],
              }}
              overlay="Delete recipient">
              <span
                className="btn-icon"
                onClick={() => removeReviewer(index)}
                onKeyPress={() => {}}
                role="button"
                data-test="addreviewerssection-delete"
                tabIndex="0">
                <FontAwesomeIcon icon={["far", "trash-alt"]} />
              </span>
            </Tooltip>
          </div>
        </div>
      ))}

    {/* ------------------- Add more users and share section ------------------- */}
    <div className="docsharingpopup-sharingform-footer">
      <div className="docsharingpopup-addmoreuser-btn">
        <Button
          className="revv-btn-secondary"
          data-test="docsharing-popup-add-btn"
          disabled={!checkFormValidation(false)}
          onClick={() => addUserToTheList()}>
          <i className="plusiconadd">
            <FontAwesomeIcon icon={["far", "plus"]} className="" />{" "}
          </i>
          &nbsp; Add recipient
        </Button>
      </div>
    </div>
  </div>
);

export default AddRecipientReviewerSection;
